import { render } from "./packages-table.vue?vue&type=template&id=aa241830"
import script from "./packages-table.vue?vue&type=script&lang=js"
export * from "./packages-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__